// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyOutlinedSvg from "@ant-design/icons-svg/es/asn/PropertySafetyOutlined";
import AntdIcon from '../components/AntdIcon';

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyOutlinedSvg
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
export default React.forwardRef(PropertySafetyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PropertySafetyOutlined.js
// module id = 1633
// module chunks = 0